// AI Theme Colors - Uses CSS variables for runtime changes
// CSS variables are defined in src/styles/_ai_colors.scss

export const AI_COLORS = {
  primary: 'var(--wh-ai-primary)',
  accent: 'var(--wh-ai-accent)',
  muted: 'var(--wh-ai-muted)',
  text: 'var(--wh-ai-text)',
  textMuted: 'var(--wh-ai-text-muted)',
} as const;

// Helper function to change AI colors at runtime
export function setAiColor(
  colorName: keyof typeof CSS_VAR_MAP,
  value: string,
): void {
  document.documentElement.style.setProperty(CSS_VAR_MAP[colorName], value);
}

const CSS_VAR_MAP = {
  primary: '--wh-ai-primary',
  accent: '--wh-ai-accent',
  muted: '--wh-ai-muted',
  text: '--wh-ai-text',
  textMuted: '--wh-ai-text-muted',
} as const;
